export const EVENT_TIMEOUT_MS = 300;
export const MENU_DROPDOWN_MAX_ROWS_IN_ONE_COLUMN = 10;
